import { FC } from 'react';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { SiteContentUpdateDateTag } from '@/modules/Sites';
import { useGetAllSitesQuery } from '@/modules/Sites/Sites/queries';

interface Props {
  currentPage: number;
  sitesListItems: BaseQueryParams<typeof useGetAllSitesQuery>['data']['items'];
  sitesListTotalItems: BaseQueryParams<typeof useGetAllSitesQuery>['data']['meta']['totalItems'];
  sitesListItemsPerPage: BaseQueryParams<typeof useGetAllSitesQuery>['data']['meta']['itemsPerPage'];
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const SitesListView: FC<Props> = ({
  currentPage,
  sitesListItems,
  sitesListTotalItems,
  sitesListItemsPerPage,
  isLoading,
  handleChangePage
}) => {
  return (
    <AppCardList
      headerTitle={ null }
      pagination={{
        current: currentPage,
        total: sitesListTotalItems,
        pageSize: sitesListItemsPerPage,
        disabled: isLoading,
        onChange: (page: number) => handleChangePage(page)
      }}
      rowKey="id"
      titleKey="name"
      grid={{
        gutter: 16,
        xs: 1,
        sm: 1,
        md: 1,
        lg: 2,
        xl: 2,
        xxl: 3
      }}
      navigateTo={ (record) => ({ to: AppRoutes.SitesById.replace(':siteId', record.id) }) }
      list={ sitesListItems }
      content={ ({ visibilityOfContentUpdateDate, contentUpdateDate }) => (
        <>
          { visibilityOfContentUpdateDate &&
            <SiteContentUpdateDateTag contentUpdateDate={ contentUpdateDate }/>
          }
        </>
      )
      }
    />
  );
};

